// libs
import styled from 'styled-components'
// static
import DotsIconOrigin from '@mui/icons-material/MoreHorizOutlined'
// utils
import { size } from 'polished'

export const DotsIcon = styled(DotsIconOrigin)`
  && {
    margin-left: auto;
    margin-top: 6px;
    cursor: pointer;
    ${size('20px')};
    transform: rotate(90deg);
    min-width: 16px;
  }
`
